import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = (theme) => ({
  root: {
    margin: theme.spacing(1),
    borderRadius: '50%',
    display: 'inline-block',
  },
});

const StatusDot = ({
  classes, className, color, size, ...rest
}) => {
  return (
    <span
      style={{
        backgroundColor: color, height: size, width: size, minWidth: size,
      }}
      className={classNames(classes.root, className)}
      {...rest}
    />
  );
};

StatusDot.defaultProps = {
  className: '',
  color: '#FFF',
  size: 8,
};

StatusDot.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
};

StatusDot.defaultProps = {
  className: '',
};

export default withStyles(styles)(StatusDot);
